import { render } from "./Message.vue?vue&type=template&id=34b33b0e"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=34b33b0e&lang=css"
script.render = render

export default script